import { Box, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";

interface PropTypes {
  data: any;
  columns: any;
  onRowClick?: Function;
}

const RepeatTables = (props: PropTypes) => {
  const { data, columns, onRowClick, ...rest } = props;

  const dataMap: any = {};
  for (const headerElem of columns) {
    const { id, name, format } = headerElem;
    dataMap[id] = {
      name,
      format,
      data: []
    };
    for (const dataElem of data) {
      var newData = dataElem[headerElem.id] ? dataElem[headerElem.id] : " ";
      dataMap[id].data.push(newData);
    }
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container>
        {Object.keys(dataMap).map(column => {
          return (
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table aria-label="spanning table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" colSpan={data.length}>
                        {dataMap[column].name}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      {...rest}
                      onClick={e => {
                        if (onRowClick) onRowClick(dataMap[column].id);
                      }}
                      tabIndex={-1}
                      key={dataMap[column].id}
                    >
                      {dataMap[column].data.map((row: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined) => {
                        const width = Math.floor(100 / data.length) + "%";
                        return (
                          <TableCell key={column} align="center" style={{ width: width }}>
                            {dataMap[column].format ? dataMap[column].format(row) : row}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default RepeatTables;
